import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/lib/fetch401Interceptor";
import App from "./App.tsx";
import "./index.css";

// Renderizar o app dentro de StrictMode
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Elemento root não encontrado no DOM");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
